import styled from 'styled-components';

import Bg from '../../../images/company/values-bg.png';

export const ValuesStyled = styled.div`
  background-color: var(--white);
  position: relative;
  .container {
    padding: 0 20px;
    @media (min-width: 992px) {
      min-height: 1165px;
      width: 100%;
      background: url(${Bg}) no-repeat center/contain;
    }
  }
  @media (min-width: 992px) {
    // min-height: 1165px;
    padding-top: 160px;
  }
`;

export const Title = styled.h1`
  color: var(--black);
  font-family: Rubik;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 40px;
  text-align: center;
  margin-bottom: 75px;
  strong {
    font-weight: bold;
  }
  @media (min-width: 992px) {
    padding-top: 57px;
    margin-bottom: unset;
  }
`;

/*padding: 36px 24px 25px 24px;*/
export const Bubble = styled.div`
  box-sizing: border-box;
  height: 250px;

  width: 100%;
  padding: 36px 24px 25px 36px;
  border-radius: 20px;
  margin-bottom: 4rem;
  position: relative;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s ease, transform 0.5s ease;
  .number {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    color: var(--dblue);
    font-family: Rubik;
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    height: 56px;
    font-size: 80px;
    top: -25px;
    right: 25px;
    opacity: 0.9;
    @media (min-width: 992px) {
      top: -30px;
    }
  }
  > h4 {
    color: var(--white);
    font-family: Rubik;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
  }
  > .text {
    color: var(--lwhite);
    font-family: Rubik;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin-top: 17px;
  }
  &::after {
    position: absolute;
    border-style: solid;
    border-color: #062147;
    border-width: 10px 15px;
    @media (min-width: 992px) {
      content: '';
    }
  }
  &.top-left {
    background: linear-gradient(225deg, #1d428a 0%, #041e42 100%);
    @media (min-width: 992px) {
      background: linear-gradient(135deg, #1d428a 0%, #041e42 100%);
      top: 115px;
      transform: translate(115px, 115px);
      .number {
        @media (min-width: 992px) {
          right: unset;
        }
      }
      &::after {
        border-left-color: transparent;
        border-bottom-color: transparent;
        bottom: -20px;
        right: 30px;
      }
    }
  }
  &.top-right {
    background: linear-gradient(225deg, #1d428a 0%, #041e42 100%);
    @media (min-width: 992px) {
      right: 0;
      top: 115px;
      transform: translate(-115px, 115px);
      &::after {
        border-right-color: transparent;
        border-bottom-color: transparent;
        bottom: -20px;
        left: 30px;
      }
    }
  }
  &.bottom-left {
    background: linear-gradient(225deg, #1d428a 0%, #041e42 100%);
    @media (min-width: 992px) {
      background: linear-gradient(95deg, #1d428a 0%, #041e42 100%);
      bottom: 140px;
      transform: translate(115px, -115px);
      .number {
        @media (min-width: 992px) {
          right: unset;
        }
      }
      &::after {
        border-left-color: transparent;
        border-top-color: transparent;
        bottom: 230px;
        right: 30px;
      }
    }
  }
  &.bottom-right {
    background: linear-gradient(225deg, #1d428a 0%, #041e42 100%);
    @media (min-width: 992px) {
      background: linear-gradient(265deg, #1d428a 0%, #041e42 100%);
      right: 0;
      bottom: 140px;
      transform: translate(-115px, -115px);
      &::after {
        border-right-color: transparent;
        border-top-color: transparent;
        bottom: 230px;
        right: 390px;
      }
    }
  }
  &.hide {
    visibility: hidden;
  }
  @media (min-width: 992px) {
    max-width: 456px;
    padding: 50px 40px 33px 40px;
    position: absolute;
    opacity: 0;
    &.transitioning {
      opacity: 1;
      transform: translate(0, 0);
      transition: opacity 1s ease, transform 1.5s ease;
      transition-delay: 0.5s;
    }
  }
  @media (max-width: 461px) {
    height: fit-content;
    color: red;
  }
`;

export const BubbleContainer = styled.div`
  width: 100%;
  min-height: 1058px;
  position: relative;
`;

export const DiagonalWhite = styled.div`
  background-color: var(--white);
  width: 100%;
  height: 100px;
  position: absolute;
  top: -100px;
  z-index: 0;
  clip-path: polygon(300% 0%, 100% 0%, 100% 100%, 0% 100%);
  @media (min-width: 992px) {
    clip-path: polygon(100% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
`;
